export default __webpack_public_path__ + "static/media/Sajdah.5bb14d22.mp3";